import React from 'react';
import Nav from '../components/nav/Nav';
import Footer from '../components/footer/Footer';
import Login from '../components/auth/Login'; // The actual login form

function LoginPage() {
  return (
    <div className='page-container'>
      <Nav />
      <div className="login-page-content page-content">
        <Login />
      </div>
      <Footer />
    </div>
  );
}

export default LoginPage;
